import { __extends } from "tslib";
import { deepMix } from '@antv/util';
import { Plot } from '../../core/plot';
import { adaptor } from './adaptor';
var Funnel = /** @class */ (function (_super) {
    __extends(Funnel, _super);
    function Funnel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /** 图表类型 */
        _this.type = 'funnel';
        return _this;
    }
    /**
     * 获取 漏斗图 默认配置项
     */
    Funnel.prototype.getDefaultOptions = function (options) {
        var compareField = options.compareField;
        return deepMix({}, _super.prototype.getDefaultOptions.call(this), {
            annotation: compareField ? function (xField, yField) { return "" + yField; } : function (xField, yField) { return xField + " " + yField; },
            label: {
                callback: function (xField, yField, percent) {
                    return {
                        content: "\u8F6C\u5316\u7387" + +percent * 100 + "%",
                    };
                },
            },
            tooltip: {
                showCrosshairs: false,
            },
        });
    };
    /**
     * 获取 漏斗图 的适配器
     */
    Funnel.prototype.getSchemaAdaptor = function () {
        return adaptor;
    };
    return Funnel;
}(Plot));
export { Funnel };
//# sourceMappingURL=index.js.map